module.exports = __webpack_public_path__ + "kz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/kz.svg
// module id = 651
// module chunks = 0